"use client";

import { useEffect } from "react";
import { ensureNavCityFromApi } from "@/lib/navCityBootstrap";

/** Resolves default nav city from `GET /cities` on first load (UUID), not legacy id `1`. */
export function NavCityBootstrap() {
  useEffect(() => {
    void ensureNavCityFromApi();
  }, []);
  return null;
}
